import React from 'react';
import './Arc.scss'; // Import your CSS for styling

const ArcReactor = () => {
    return (
        <div style={{ position: 'fixed', height: '100%', width: '100%' }}>
            <div className="arc_reactor">
                <div className="case_container">
                    <div className="e7">
                        <div className="semi_arc_3 e5_1">
                            <div className="semi_arc_3 e5_2">
                                <div className="semi_arc_3 e5_3">
                                    <div className="semi_arc_3 e5_4"></div>
                                </div>
                            </div>
                        </div>
                        <div className="core2"></div>
                    </div>
                    <ul className="marks">
                        <li></li><li></li><li></li><li></li><li></li><li></li>
                        <li></li><li></li><li></li><li></li><li></li><li></li>
                        <li></li><li></li><li></li><li></li><li></li><li></li>
                        <li></li><li></li><li></li><li></li><li></li><li></li>
                        <li></li><li></li><li></li><li></li><li></li><li></li>
                        <li></li><li></li><li></li><li></li><li></li><li></li>
                        <li></li><li></li><li></li><li></li><li></li><li></li>
                        <li></li><li></li><li></li><li></li><li></li><li></li>
                        <li></li><li></li><li></li><li></li><li></li><li></li>
                        <li></li><li></li><li></li><li></li><li></li><li></li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ArcReactor;
